import type { ReactNode } from 'react';
import { Box } from '@simplywallst/ui-core';

type Props = {
  children: ReactNode;
};
export const Header = ({ children }: Props) => {
  return (
    <Box position="absolute" top="0" width="100%">
      {children}
    </Box>
  );
};
